import { CheckCircle, RadioButtonUnchecked } from '@mui/icons-material';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { QueryFilters } from '@tanstack/react-query';
import { format } from 'date-fns';
import React from 'react';
import { tableColumnsStaff } from '.';
import { AgtStaffPermissions, MyStaffData } from '../../types';
import { StaffRowManage } from './staff-row-manage';

export function StaffRow(props: {
  row: MyStaffData;
  queryKey: QueryFilters['queryKey'];
}) {
  // Props
  const { row } = props;

  return (
    <React.Fragment>
      <TableRow
        sx={{
          '&:nth-of-type(odd)': {
            backgroundColor: '#f9f9f9',
          },
        }}
      >
        {tableColumnsStaff.map((column) => {
          const align = column.align || 'center';
          switch (column.key) {
            case 'Active': {
              return (
                <TableCell
                  key={column.key}
                  align={align}
                  sx={{
                    fontFamily: 'Roboto Mono',
                    color: row.Active ? 'green' : 'grey',
                    fontWeight: 'bold',
                  }}
                >
                  {row.Active ? 'Active' : 'Inactive'}
                </TableCell>
              );
            }
            case 'CreatedDate': {
              return (
                <TableCell
                  key={column.key}
                  align={align}
                  sx={{ fontFamily: 'Roboto Mono' }}
                >
                  {format(new Date(row[column.key]), 'yyyy-MM-dd')}
                </TableCell>
              );
            }
            case 'Email': {
              return (
                <TableCell key={column.key} align={align}>
                  <a href={`mailto:${row.Email}`}>{row.Email}</a>
                </TableCell>
              );
            }
            case 'LName': {
              return (
                <TableCell key={column.key} align={align}>
                  {row.LName}, {row.FName}
                </TableCell>
              );
            }
            case 'Username': {
              return (
                <TableCell
                  key={column.key}
                  align={align}
                  sx={{ fontFamily: 'Roboto Mono', color: '#b26500' }}
                >
                  {row.Username}
                </TableCell>
              );
            }

            default: {
              return (
                <TableCell key={column.key} align={align}>
                  {row[column.key]}
                </TableCell>
              );
            }
          }
        })}
        <TableCell align="center">
          {row.Permissions.includes(AgtStaffPermissions['Commissions']) ? (
            <CheckCircle color="success" />
          ) : (
            <RadioButtonUnchecked sx={{ color: 'grey' }} />
          )}
        </TableCell>
        <TableCell align="center">
          {row.Permissions.includes(AgtStaffPermissions['Debts']) ? (
            <CheckCircle color="success" />
          ) : (
            <RadioButtonUnchecked sx={{ color: 'grey' }} />
          )}
        </TableCell>
        <TableCell align="center">
          {row.Permissions.includes(AgtStaffPermissions['Profile']) ? (
            <CheckCircle color="success" />
          ) : (
            <RadioButtonUnchecked sx={{ color: 'grey' }} />
          )}
        </TableCell>
        <TableCell align="center">
          {row.Permissions.includes(AgtStaffPermissions['Wallet']) ? (
            <CheckCircle color="success" />
          ) : (
            <RadioButtonUnchecked sx={{ color: 'grey' }} />
          )}
        </TableCell>
        <TableCell align="center">
          <StaffRowManage row={row} queryKey={props.queryKey} />
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
